export const ending = (contractor: any) => {
  return [
    {
      text: [
        { text: '     IN WITNESS WHEREOF', bold: true },
        { text: ", intending to be legally bound, the parties hereto have executed this TICA as of the day and year first above written. By its signature below, Independent Contractor acknowledges receipt of two complete, signed copies of this TICA and all of its attachments.", style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      columns: [
        {
          width: '50%',
          text: [
            { text: 'COMPANY:', bold: true, color: '#058ff4' },
            { text: '\n' },  // Proper line break
            { text: 'Sierra Expediting Inc.', bold: true },
            { text: '\n' },
            { text: 'Signature: ', bold: true },
            { text: '_______________________' },
            { text: '\n' },
            { text: 'Print Name: ', bold: true },
            { text: '_____________________________________' },
            { text: '\n' },
            { text: 'Title: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
            { text: 'Date: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
          ],
        },

        {
          width: '50%',
          text: [
            { text: 'INDEPENDENT CONTRACTOR:', bold: true, color: '#058ff4' },
            { text: '\n' },
            { text: `${contractor.name}`, bold: true },
            { text: '\n' },
            { text: 'Signature: ', bold: true },
            { text: '_______________________' },
            { text: '\n' },
            { text: 'Print Name: ', bold: true },
            { text: '_____________________________________' },
            { text: '\n' },
            { text: 'Title: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
            { text: 'Date: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
          ],
        },
      ],
      style: 'p',
    },
  ];
};
